module.exports = __webpack_public_path__ + "static/media/speech-bubble-grey.6b329267.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/speech-bubble-grey.svg
// module id = 215
// module chunks = 0